import type * as VisibilityBundle from '@foundation-player/plugin-visibility';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createVisibilityPlugin: PluginFactoryFunction = (builderConfig) => {
  const visibilityPackage = PackageName.PluginVisibility;

  return [
    [visibilityPackage],
    () => {
      const visibilityGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[visibilityPackage];

      return [
        new (resolveByPackageNameOrThrow<typeof VisibilityBundle>(visibilityPackage).VisibilityPlugin)(
          builderConfig.pluginConfigs[visibilityGlobalName] as VisibilityBundle.PluginConfig,
        ),
      ];
    },
  ];
};
